import ViewController from "core/views/view.controller";
import Moment from "moment";
import DateDaySelection from "./date-day-selection";
import DateWeekSelection from "./date-week-selection";
import MonthSelection from "./date-month-selection";

export default class WeekDataSelectionCtrl extends ViewController {
    static $inject = ['$scope', 'settings'];

    constructor() {
        super(...arguments);

        this.dateSelection = null;
        this.daySelection = new DateDaySelection(this.settings.calendarWithSunday);
        this.weekSelection = new DateWeekSelection();
        this.monthSelection = new MonthSelection();

        if (!this.selectedDate) {
            this.selectedDate = Moment();
        }

        // Bindings
        this.selectedDate = Moment();
        this.selectionMode = 'day';
        this.onDateSelected = null;
        this.onNextRange = null;
        this.onPrevRange = null;

        this.updateSelectionMode(this.selectionMode);
        this.dateSelection.setDate(this.selectedDate);
    }

    $onInit() {
        this.$scope.$on('weekDateSelection.nextDate', () => {
            this.nextDate();
        });

        this.$scope.$on('weekDateSelection.prevDate', () => {
            this.prevDate();
        });
    }

    $onChanges(changes) {
        if(changes.selectionMode && this.selectionMode == null){
            this.selectionMode = 'day';
        }

        if (changes.selectedDate && this.selectedDate) {
            this.dateSelection.setDate(this.selectedDate);
        }

        if (changes.selectionMode && this.selectionMode) {
            this.updateSelectionMode(this.selectionMode);
            this.dateSelection.setDate(this.selectedDate);
        }
    }

    updateSelectionMode(selectionMode) {
        this.selectionMode = selectionMode;

        if (this.selectionMode == 'day') {
            this.dateSelection = this.daySelection;

        } else if (this.selectionMode == 'week') {
            this.dateSelection = this.weekSelection;

        } else if (this.selectionMode == 'month') {
            this.dateSelection = this.monthSelection;

        } else {
            throw "Unknown selection mode: " + selectionMode;
        }
    }

    prevRange() {
        this.dateSelection.prevRange();

        if (this.onPrevRange instanceof Function) {
            this.onPrevRange({dates: this.dateSelection.dates});
        }
    };

    nextRange() {
        this.dateSelection.nextRange();

        if (this.onNextRange instanceof Function) {
            this.onNextRange({dates: this.dateSelection.dates});
        }
    }

    nextDate() {
        var date = this.dateSelection.nextDate();

        if (this.onDateSelected instanceof Function) {
            this.onDateSelected({date: Moment(date)});
        }
    }

    prevDate() {
        var date = this.dateSelection.prevDate();

        if (this.onDateSelected instanceof Function) {
            this.onDateSelected({date: Moment(date)});
        }
    }

    selectDate(date) {
        if (this.dateSelection.isSelected(date)) {
            return;
        }

        this.selectedDate = date;
        this.dateSelection.setDate(date);

        if (this.onDateSelected instanceof Function) {
            this.onDateSelected({date: Moment(date)});
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/week-date-selection/week-date-selection.controller.js